const set = {
	setRates: "preferences/rates/setRates",
};

const constants = Object.seal(set);
export default constants;
